export enum View {
  ENTER_EMAIL = "ENTER_EMAIL",
  ENTER_PASSWORD = "ENTER_PASSWORD",
  ENTER_CODE = "ENTER_CODE",
  ENTER_MFA = "ENTER_MFA",
  // Ask user that is linking password account to SSO to enter their password
  CONFIRM_PASSWORD = "CONFIRM_PASSWORD",
  // Add password to account
  CREATE_PASSWORD = "CREATE_PASSWORD",
  // Reset password via email
  RESET_PASSWORD = "RESET_PASSWORD",
  LOADING = "LOADING",
  // Prompt user that signed up with SSO to hit their social login button
  SSO = "SSO",
  // Prompt user to select an mfa option if applicable
  SELECT_MFA_OPTION = "SELECT_MFA_OPTION",
  // Unified login view replacing ENTER_EMAIL and ENTER_PASSWORD
  ENTER_LOGIN = "ENTER_LOGIN",
  // Shows up after user puts a wrong password and get a auto sign in link
  AUTO_SIGN_IN_LINK_SENT = "AUTO_SIGN_IN_LINK_SENT",
  // Shows up after user choose to receive SMS or email code in new MFA experience options
  ENTER_MFA_CODE = "ENTER_MFA_CODE",
  // Shows up after user choose to receive email code in new MFA experience options
  MFA_OPTIONS_EMAIL_SENT = "MFA_OPTIONS_EMAIL_SENT",
}
